
import { SMUser } from "@/store";
import { Component, Prop, Vue } from "vue-property-decorator";

const CLASS = "block";

@Component
export default class IconBlock extends Vue {
  @Prop({ type: Number, default: 0 }) readonly count!: number;

  get classes() {
    return {
      [`${CLASS}_tasks`]: !this.isComplianceBlocked,
      [`${CLASS}_disabled`]: this.isComplianceBlocked,
    };
  }

  get tasksLabel() {
    return this.count > 1 ? "tasks" : "task";
  }

  get isComplianceBlocked() {
    return SMUser.user?.is_compliance_blocked;
  }

  onClick() {
    this.$emit("click");
  }
}
